export default "__VITE_ASSET__B4R2k61U__"